/**
 * User: herbert
 * Date: 14.02.16
 * Time: 18:40
 */

import queryString from 'query-string';

import tDE from './translate--de.js';
import tEN from './translate--en.js';
import tFR from './translate--fr.js';

const TRANSLATIONS = {
	de: tDE,
	en: tEN,
	fr: tFR
};

const langString = (typeof window !== 'undefined' && window.location) ?
	queryString.parse(window.location.search).lang :
	typeof global !== 'undefined' && global.lang;
const lang = (langString === 'de' || langString === 'en' || langString === 'fr') ? langString : 'en';

const regionString = (typeof window !== 'undefined' && window.location) ?
	queryString.parse(window.location.search).region :
	typeof global !== 'undefined' && global.region;
const region = (regionString === 'fr' ? regionString : 'de');

export default {
	lang: lang, // API for translate-sx
	region: region,
	current: TRANSLATIONS[lang],
	/* eslint no-irregular-whitespace: 0, prefer-const: 0 */
	toFixed: function (/**Number*/ value, /**Number*/precision) {
		let str = Math.round(value * Math.pow(10, precision)).toString(10);
		//if(!str || !value) console.log("T.toFixed missing value: ", value, precision, str);
		let pos = str.length - precision;
		// use a small blank to group the thousands. that's to have some visually hint but saves us to enter nls hell
		//if(pos>3) {
		//	str = str.substring(0, pos-3) + ' ' + str.substring(pos-3); // ATTENTION: don't touch the special blank U+2009 in the string
		//	pos++;
		//}
		if (precision > 0)
			return str.substring(0, pos) + TRANSLATIONS[lang].MATH.FRACTION + str.substr(pos);
		else
			return str;
	},
	// TODO region and use productsdb terminology: int,aut,bel,aus,can,ger,ita,lux,ned,swe,tur,gbr
	//region: null, // FIXME set according to visited site
	currency: '€' // currency is not a property of the translated languages, but from the international site visited // FIXME set according to visited site
};
